module.exports = {
    endpoint: 'https://admin.vercanminimizados.com/api/v1/'
};
